export interface ResearchReport {
  symbol: string;
  generatedAt: string;

  analystRating: {
    consensus: 'strong_buy' | 'buy' | 'hold' | 'sell' | 'strong_sell';
    confidence: number; // 0-100
    reasoning: string;
  };

  keyMetrics: {
    pe: number | null;
    forwardPe: number | null;
    eps: number | null;
    dividendYield: number | null;
    beta: number | null;
    fiftyTwoWeekLow: number | null;
    fiftyTwoWeekHigh: number | null;
    priceToBook: number | null;
    debtToEquity: number | null;
    revenueGrowth: number | null;
    profitMargin: number | null;
  };

  macroFactors: Array<{
    factor: string;
    impact: 'positive' | 'neutral' | 'negative';
    description: string;
  }>;

  earningsInfo: {
    nextDate: string | null;
    recentHighlights: string[];
    links: string[];
  };

  technicalAnalysis: {
    support: number | null;
    resistance: number | null;
    trend: 'bullish' | 'neutral' | 'bearish';
    signals: string[];
  };

  riskFactors: string[];
  opportunities: string[];

  summary: string; // markdown executive summary (2-3 paragraphs)

  disclaimer: string;
}

export interface ResearchResponse {
  report: ResearchReport;
  cachedAt: string;
  isDemo: boolean;
  usage?: {
    used: number;
    limit: number;
  };
}

export interface ResearchStatusResponse {
  hasReport: boolean;
  report: ResearchReport | null;
  cachedAt: string | null;
  isDemo: boolean;
  usage: {
    used: number;
    limit: number;
  };
}

export interface ResearchHistoryEntry {
  generatedAt: string;
  cachedAt: string;
  consensus: ResearchReport['analystRating']['consensus'];
  confidence: number;
}

export const RESEARCH_CONFIG = {
  cacheTTLSeconds: 1209600, // 14 days
  monthlyLimitPerUser: 50,
  usageTTLSeconds: 3888000, // 45 days
  demoSymbol: 'NVDA',
} as const;
